import { useEffect, useState } from 'react'

const DEFAULT_IDLE_TIMEOUT_MS = 500

/**
 * true après requestIdleCallback (ou timeout) — pour différer les requêtes non critiques post-bootstrap.
 */
export function useDeferredReady(timeoutMs = DEFAULT_IDLE_TIMEOUT_MS): boolean {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false
    const markReady = () => {
      if (!cancelled) setReady(true)
    }

    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      const id = window.requestIdleCallback(markReady, { timeout: timeoutMs })
      return () => {
        cancelled = true
        window.cancelIdleCallback(id)
      }
    }

    const timer = window.setTimeout(markReady, timeoutMs)
    return () => {
      cancelled = true
      window.clearTimeout(timer)
    }
  }, [timeoutMs])

  return ready
}

/**
 * Idle defer uniquement quand `when` est true (ex. hover cloche notifications).
 */
export function useDeferredReadyWhen(when: boolean, timeoutMs = DEFAULT_IDLE_TIMEOUT_MS): boolean {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (!when) {
      setReady(false)
      return
    }

    let cancelled = false
    const markReady = () => {
      if (!cancelled) setReady(true)
    }

    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      const id = window.requestIdleCallback(markReady, { timeout: timeoutMs })
      return () => {
        cancelled = true
        window.cancelIdleCallback(id)
      }
    }

    const timer = window.setTimeout(markReady, timeoutMs)
    return () => {
      cancelled = true
      window.clearTimeout(timer)
    }
  }, [when, timeoutMs])

  return when && ready
}
